export default __webpack_public_path__ + "static/media/1551.1dc4204d.png";